import { z } from "zod/v4";

import { createZodStringOption } from "components/Forms/utils/validation.utils";

const CsfcRequiredSchema = z.object({
  csfc_eligible: z.enum(["Yes", "Maybe"]),
  csfc_components: z.array(createZodStringOption()).min(1),
});

const CsfcExcludedSchema = z.object({
  csfc_eligible: z.enum(["No"]),
  csfc_components: z.array(createZodStringOption()).length(0),
});

const CsfcEmptySchema = z.object({
  csfc_eligible: z
    .literal("")
    .refine(() => false, "Please select an eligibility"),
  csfc_components: z.array(createZodStringOption()).length(0),
});

export const CsfcDraftSchema = z.object({
  csfc_eligible: z.enum(["Yes", "No", "Maybe", ""]).optional(),
  csfc_components: z.array(createZodStringOption()),
});

export const CsfcSchema = z.discriminatedUnion("csfc_eligible", [
  CsfcRequiredSchema,
  CsfcExcludedSchema,
  CsfcEmptySchema,
]);
